export default __webpack_public_path__ + "static/media/2d32c13917262e7d.550ea7e575a68cd858e351f85910b9be.svg";